import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {ModalService} from '../../../services/modal/modal.service';
import {GraphServiceService} from '../../../services/graph-service.service';
import {CrmService} from '../../../services/api/crm.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {TaskBoardModel} from '../../../models/tasktable.model';
import {IGraphNode} from '../../../modules/graph-konva/models/graph-kn.model-interfaces';

@Component({
    selector: 'app-status-buttons',
    templateUrl: './status-buttons.component.html',
    styleUrls: ['./status-buttons.component.scss']
})
export class StatusButtonsComponent implements OnInit {
    @Output() isDeleteModeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() createDataEmit: EventEmitter<any> = new EventEmitter<any>();
    @Input() creatingBoard: TaskBoardModel;
    @Input() isOnlyCreateStatusButton = false;
    @Input() graphGenerate = true;

    isDeleteMode = false;
    isShowIcons = false;
    color: string;
    isUniversal = false;
    isSuccessful = false;

    nodesWithoutArchive: IGraphNode[] = [];

    constructor(
        public modalService: ModalService,
        public graphService: GraphServiceService,
        public crmService: CrmService,
    ) {
    }

    ngOnInit(): void {
        if (this.isOnlyCreateStatusButton) {
            void this.graphService.selectBoard(this.creatingBoard, true, this.graphGenerate);
        }
    }

    onOpenModal(content: TemplateRef<any>): void {
        this.modalService.openTemplateModal(content);
        this.nodesWithoutArchive = this.graphService.nodes.filter(x => !x.bp_status_data?.is_archive && !x.bp_status_data?.is_universal);
    }

    setIcon(icon): void {
        this.graphService.svgIcons.selectedSvg = Object.assign({}, icon);
        this.isShowIcons = false;
    }

    changeMode(): void {
        this.isDeleteMode = !this.isDeleteMode;
        this.isDeleteModeEvent.emit(this.isDeleteMode);
    }

    onCreateStatus(title: string, description: string, isUniversal: boolean, color: string, modal: NgbModalRef): void {
        this.graphService.createNodeStatus(title, description, isUniversal, color, this.isSuccessful, modal)
            .then(res => {
                this.createDataEmit.emit(res);
                this.isUniversal = false;
                this.isSuccessful = false;
            });
    }
}
